import React, { useEffect} from "react";
import { appUrl } from "../../../constants/url-constants";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import Button from "../../shared/button";
import SellTradeInCarValuation from "../sell-trade-in-car-valuation";
import getStepInfo from "../../../utils/trade-in-helper/get-current-step-info";
import styles from "./styles.css";

// tracking
import { trackDesktopCustomEventsAU } from "../../../tracking";
import { AU_DESKTOP_EVENTS } from "../../../tracking/au.desktop-events";

const TradeInAnotherCar = ({
    tradeInData,
    step,
    setTradeInToggleVisibleStateConnect
}) => {
    const history = useHistory();

    const { c2bOrderId, c2bEligible} = tradeInData;
    const { heading, description, ctaText, lastStep, gaKey, screenLoadGa } = getStepInfo(step, c2bEligible);

    useEffect(() => {
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.MY_ACCOUNT_SELL_OR_TRADE_IN_SCREEN, {
            eventAction: screenLoadGa,
            eventLabel: "NA"
        });
    }, [screenLoadGa]);

    const handleClickHandler = () => {
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.MY_ACCOUNT_CTA_CLICKED, {
            eventLabel: gaKey
        });
        if (step === "SELECT_DAY") {
            history.push(`/book-inspection/${c2bOrderId}/select-day`);
        } else if (step === "CAR_SELECTION") {
            setTradeInToggleVisibleStateConnect();
            window.location.href = `${appUrl()}/buy-used-cars-australia`;
        } else {
            history.push(`/sell-my-car/${lastStep}/${c2bOrderId}`);
        }
    };

    return (
        <div>
            <div styleName={"styles.outer"}>
                <SellTradeInCarValuation
                    heading={heading}
                    description={description}
                    tradeInData={tradeInData}
                />
            </div>
            <div styleName="styles.buttonCtn">
                <Button text={ctaText} onClick={handleClickHandler} />
            </div>
        </div>
    );
};

TradeInAnotherCar.propTypes = {
    tradeInData: PropTypes.object,
    step: PropTypes.string,
    setTradeInToggleVisibleStateConnect: PropTypes.func
};

export default TradeInAnotherCar;
